<template>
  <a :title="title" :href="`tel:${value}`" v-if="value">
    {{ value }}
  </a>
</template>

<script>
export default {
  props: {
    value: {
      default: false,
    },
    title: {
      default: null,
      type: String,
      required: false,
    },
  },
};
</script>
